"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.FileInsertAthenaQuerySchema = exports.DataAccessor = void 0;
const _imports_1 = require("../_imports");
const _shared_1 = require("../_shared");
const AthenaConfig_1 = require("../AthenaConfig");
const GlobalRecurringDate = __importStar(require("../GlobalRecurringDate"));
const ColumnConfig = __importStar(require("./ColumnConfig"));
const DataAccessor = __importStar(require("./Inputs/DataAccessor"));
exports.DataAccessor = DataAccessor;
// ************   CONFIG   ************
/**
 * In general, Athena & DataAccessor (Postgres) act as gateways to our persistent data.
 * Intermediate fields are outputs from layering on calculations to these source data.
 * The evaluation flow would follow:
 * globalRecurringDateConfigs --> Athena | DataAccessor --> Intermediate Fields
 *
 * These "inputs" basically represent variables that would be made available for
 * the output sheets to utilize
 */
// File Insert Athena Query schema - used for xlsx file insertion
exports.FileInsertAthenaQuerySchema = AthenaConfig_1.QuerySchema.extend({
    columns: _imports_1.z.array(ColumnConfig.Schema),
});
// Zod schema for Config
exports.ConfigSchema = _imports_1.z.object({
    globalRecurringDateConfigs: _imports_1.z.array(GlobalRecurringDate.ConfigSchema),
    athenaQueries: _imports_1.z.array(AthenaConfig_1.QuerySchema),
    athenaRecurringQueries: _imports_1.z.array(AthenaConfig_1.RecurringQuerySchema),
    dataAccessors: _imports_1.z.array(DataAccessor.AccessorSchema),
    intermediateFields: _imports_1.z.array(_shared_1.ReportingInputsIntermediateFieldSchema),
    fileInsertAthenaQueries: _imports_1.z.array(exports.FileInsertAthenaQuerySchema).optional(),
});
//# sourceMappingURL=Inputs.js.map